const bannerImages = [
  {
    link: "/search/gaming laptops",
    image: "https://d5phhptdhx7pz.cloudfront.net/assets/images/1786648584062-2-banner1.jpeg",
  },
  {
    link: "/search/refurbished",
    image: "https://d5phhptdhx7pz.cloudfront.net/assets/images/1786648584062-3-Banner2.jpg",
  },
];

const bannerImagesMobile = [
  {
    link: "/search/gaming laptops",
    image: "https://d5phhptdhx7pz.cloudfront.net/assets/images/1786648584062-1-banner-mobile2.jpg",
  },
  {
    link: "/search/refurbished",
    image: "https://d5phhptdhx7pz.cloudfront.net/assets/images/1786648584062-0-banner-Mobile1.jpg",
  },
];

const domain = "rockmycart.com";
const domainName = "rockmycart";
const domainName2 = "Rock My Cart";
const licenseNumber = "7007570";
const customerSupport = "8:00 AM to 10:00 PM UAE Time, 7 days a week";
const companyName = "Online World FZ LLC";
const domainLogo = "/rockmycart.png";
const bgColor = "#000";
const favicon = "/favicon.png";
const email = "help@rockmycart.com";
const metaTitle = "Rockmycart: Your One-Stop Shop for Affordable Deals and Quality Products";
const metaDescription =
  "RockMyCart is a UAE-based e-commerce platform offering rock bottom deals on electronics, fashion, gadgets, accessories and more. Built to make online shopping fast, exciting, and affordable.";
const headerBg = "#000";
const subMenu = "#000";

const buttonColor = "#f7f7f7";
const address =
  "Compass Building<br />FDCW1862, Al Shohada Road<br /> Al Hamra Industrial Zone-FZ<br />Ras Al Khaimah, United Arab Emirates";
const phone = "+971 4 836 9557";

const Host = {
  domain: domain,
  domainName: domainName,
  domainName2: domainName2,
  licenseNumber: licenseNumber,
  customerSupport: customerSupport,
  companyName: companyName,
  domainLogo: domainLogo,
  bgColor: bgColor,
  favicon: favicon,
  email: email,
  metaTitle: metaTitle,
  metaDescription: metaDescription,
  headerBg: headerBg,
  subMenu: subMenu,
  bannerImages: bannerImages,
  bannerImagesMobile: bannerImagesMobile,
  buttonColor: buttonColor,
  address: address,
  phone: phone,
};

export default Host;
